import clsx from 'clsx'

import styles from './NewWishlistNameInput.module.scss'

type NewWishlistNameInputProps = {
  className?: string
  placeholder?: string
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
} & React.InputHTMLAttributes<HTMLInputElement>

export function NewWishlistNameInput({
  className,
  placeholder,
  value,
  onChange,
  ...rest
}: NewWishlistNameInputProps) {
  const classNames = clsx(styles.input, className)
  return (
    <input
      {...rest}
      className={classNames}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  )
}
